module.exports = __webpack_public_path__ + "img/structureComposantes.e4e0f503.png";